export const MSG_SAVE_SUCCESS = 'Saved successfully.';
export const MSG_ERROR = 'Sorry, an error occurred. Please try again later.';
export const MSG_PAYMENT_REQUIRED = 'Payment required.';
